<p-toast></p-toast>

<section class="admin-page">
    <app-admin-page-header [title]="title" [subtitle]="subtitle">
        <div header-actions style="display: contents">
            <button class="admin-btn admin-btn--primary" type="button" (click)="openCreateAnnouncementDialog()">
                Novo Anúncio
            </button>
        </div>
    </app-admin-page-header>

    <div class="admin-surface admin-surface__section">
        <div class="admin-detail-card">
            <p-table [value]="announcements" [paginator]="true" [rows]="rowsPerPage" [totalRecords]="totalAnnouncements"
                [lazy]="true" [loading]="isLoadingAnnouncements" (onLazyLoad)="onLazyLoad($event)"
                styleClass="admin-table hoverable">
                <ng-template pTemplate="header">
                    <tr>
                        <th>ID</th>
                        <th>Título</th>
                        <th>Imagem</th>
                        <th>Link</th>
                        <th>Ativo?</th>
                        <th>Ações</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-announcement>
                    <tr>
                        <td>{{announcement.id}}</td>
                        <td>{{announcement.title}}</td>
                        <td>
                            <a [href]="announcement.image_url" target="_blank" rel="noopener noreferrer">
                                <img class="announcement-thumb" [src]="announcement.image_url" [alt]="announcement.title" />
                            </a>
                        </td>
                        <td>
                            <a [href]="announcement.deeplink" target="_blank" rel="noopener noreferrer">
                                {{announcement.deeplink}}
                            </a>
                        </td>
                        <td>
                            <span class="status-badge" [ngClass]="announcement.is_active ? 'status-badge--success' : 'status-badge--danger'">
                                {{announcement.is_active ? 'Ativo' : 'Inativo'}}
                            </span>
                        </td>
                        <td>
                            <button *ngIf="announcement.is_active" class="admin-btn admin-btn--danger" type="button"
                                [disabled]="deactivatingId === announcement.id"
                                (click)="deactivateAnnouncement(announcement)">
                                Desativar
                            </button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <p-dialog header="Criar Novo Anúncio" styleClass="admin-dialog" [(visible)]="displayCreateAnnouncementModal"
        [modal]="true" maskStyleClass="dialog-mask" [dismissableMask]="true" [draggable]="false" [appendTo]="'body'"
        [style]="{width: '40vw'}">
        <app-announcement-form (announcementCreated)="createAnnouncementSuccess()"></app-announcement-form>
    </p-dialog>
</section>
